export const nav = [
  'BACK', // Navigation to previous step.
  'FORWARD', // Navigation to next step.
  'JUMP', // Navigation to a non-adjacent step.
  'NONE' // No navigation.
].reduce((result, key) => { result[key] = key; return result; }, {});

export const stepDeltaToDirection = {
  1: nav.FORWARD,
  0: nav.NONE,
  [-1]: nav.BACK
};
